import { CDN_EXTERNALS, NODE_ENV } from '../../config/common.config';
import { TAG_MANAGER_PROFILE } from '../../config/client.config';
import { loadScript, toExternalScript } from '../helpers/scripts';
import { loadSentry } from '../helpers/errors';

declare global {
  interface Window {
    dataLayer: object[];
    CookieConsent: any;
  }
}

export function getAppAssets(manifest): string {
  if (NODE_ENV === 'development') {
    return toExternalScript('/assets/main.development.js');
  }

  return [
    ...CDN_EXTERNALS.map((name) => manifest[`${name}.js`]), // by dynamic-cdn-webpack-plugin
    manifest['vendors~main.js'],
    manifest['main.js'],
  ]
    .map(toExternalScript)
    .join(' ');
}

export function appendExternalScripts(): void {
  let hasAnalyticsScripts = false;

  function loadGTM(): void {
    loadScript({
      src: `//www.googletagmanager.com/gtm.js?id=${TAG_MANAGER_PROFILE}`,
      async: true,
    });
    window.dataLayer = [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      'event': 'gtm.js',
    });
  }

  loadGTM();

  function appendAnalyticsScripts(): void {
    const consent = window.CookieConsent.getConsent();
    if (consent && consent.includes('analytics') && !hasAnalyticsScripts) {
      loadSentry();
      hasAnalyticsScripts = true;
    }
  }

  appendAnalyticsScripts();
  window.addEventListener('cookieConsent.set', appendAnalyticsScripts);
  window.dispatchEvent(new Event('cookieConsent.set'));
}

export function getTagManagerIframe(): string {
  return `<noscript>
    <iframe src="//www.googletagmanager.com/ns.html?id=${TAG_MANAGER_PROFILE}" height="0" width="0" style="display:none;visibility:hidden"></iframe>
  </noscript>`;
}

export function getCookieConsent(manifest): string {
  return toExternalScript(manifest['cookie-consent.js']);
}
